export default [
  {
    type: 'Change Business Name',
    description: 'Sometimes a business needs a facelift, a rebranding.',
    icon: 'Clock',
    price: 10000
  },
];